export default class JsBridge {
  static INSTANCE;

  static getInstance = () => {
    if (!JsBridge.INSTANCE) JsBridge.INSTANCE = new JsBridge();
    return JsBridge.INSTANCE;
  };

  constructor() {
    this.call = (name, opt, cb) => {
      if (window.AlipayJSBridge && window.AlipayJSBridge.call) {
        window.AlipayJSBridge.call(name, opt, cb);
      }
    };
  }

  on = (event, fn) => {
    document.addEventListener(event, fn, false);
  };

  off = (event, fn) => {
    document.removeEventListener(event, fn, false);
  };

  setTitle = (titleArgs = '') => {
    const title = titleArgs.trim();

    if (window.IS_IN_SKYWALKER) {
      this.call('setTitle', {
        title,
      });
    } else {
      document.title = title;
    }
  };

  setOptionMenu = opt => {
    this.call('setOptionMenu', opt);
  };

  hideOptionMenu = () => {
    this.call('hideOptionMenu');
  };

  showOptionMenu = () => {
    this.call('showOptionMenu');
  };

  setDefaultBack = () => {
    this.call('setCloseButton', { action: 'hide' });
    this.call('setBackButton', { action: 'show' });
  };

  close = () => {
    this.call('closeSubApp', { event: 'top' });
  };
}
